interface Props {
  label: string;
  className?: string;
  labelClassName?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
}

export const RedButton = ({
  label,
  className,
  onClick,
  labelClassName,
  ...rest
}: Props) => {
  return (
    <button
      {...rest}
      onClick={onClick}
      className={`bg-red-400 px-6 py-1 hover:opacity-90 rounded-[5px] active:bg-red-300 transition ease-linear ${className}`}
    >
      <p
        className={`font-satoshi  font-medium text-white text-base ${labelClassName}`}
      >
        {label}
      </p>
    </button>
  );
};
